import React, { useEffect, useState } from 'react';
import { getImpersonation, endImpersonation } from 'services/impersonation';

// Blocks the app once an impersonated session expires. The live indicator
// lives in the header (see ImpersonationBadge) so it never covers content.
export default function ImpersonationBoundary({ children }) {
  const [now, setNow] = useState(Date.now());
  const session = getImpersonation();
  const active = Boolean(session);
  useEffect(() => {
    if (!active) return undefined;
    const timer = window.setInterval(() => setNow(Date.now()), 1000);
    return () => window.clearInterval(timer);
  }, [active]);
  if (!session) return children;
  if (session.expiresAt <= now) {
    return (
      <main style={{ padding: 32 }}>
        <h1>La sesión de soporte terminó</h1>
        <p>
          Para continuar como este usuario, iniciá otra sesión desde el
          backoffice.
        </p>
        <button onClick={endImpersonation}>Salir del modo soporte</button>
      </main>
    );
  }
  return children;
}
